module.exports = __webpack_public_path__ + "img/msg_bg_active.png";